module.exports = __webpack_public_path__ + "static/media/arrow-right-white.6c4d49ad.svg";